(function () {
  function initKhb(root) {
    if (!root || root.dataset.khbBound === 'true') return;
    root.dataset.khbBound = 'true';
    
      
      

      var stageImage = root.querySelector('[data-khb-stage-image]');
      var stageVideo = root.querySelector('[data-khb-stage-video]');
      var hotspotButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hotspot-btn]'));
      var popovers = Array.prototype.slice.call(root.querySelectorAll('[data-popover]'));
      var defaultCopy = root.querySelector('[data-khb-default-copy]');
      var revealNodes = Array.prototype.slice.call(root.querySelectorAll('[data-khb-reveal]'));
      var benefitRevealNodes = Array.prototype.slice.call(root.querySelectorAll('[data-khb-benefit-reveal]'));
      var benefitCards = Array.prototype.slice.call(root.querySelectorAll('[data-khb-benefit]'));

      var defaultImageSrc = stageImage && stageImage.tagName === 'IMG' ? (stageImage.getAttribute('src') || '') : '';
      var defaultImageAlt = stageImage && stageImage.tagName === 'IMG' ? (stageImage.getAttribute('alt') || '') : '';

      var activeHotspotId = null;
      var activeRequestId = 0;
      var clearVideoTimer = null;
      var loadTimeoutTimer = null;
      var resetPopoverTimer = null;
      var mobileScrollStartY = 0;
      var mobileScrollAccumulated = 0;

      var VIDEO_FADE_MS = Number(root.dataset.khbCrossfadeMs) || 220;
      var ROTATE_MS = Number(root.dataset.khbRotateMs) || 520;
      var DESKTOP_BREAKPOINT = 990;
      var VIDEO_LOAD_TIMEOUT_MS = 4500;
      var POPOVER_TRANSITION_MS = 220;
      var MOBILE_SCROLL_CLOSE_THRESHOLD = Number(root.dataset.khbScrollClose) || 44;

      var mediaCache = Object.create(null);
      var prefersReducedMotion = false;

      try {
        prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      function cssEscapeSafe(str) {
        if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(str);
        return String(str).replace(/([ #;?%&,.+*~\\':"!^$[\]()=>|/@])/g, '\\$1');
      }

      function isDesktop() {
        return window.innerWidth >= DESKTOP_BREAKPOINT;
      }

      function isVideoReady(video) {
        return !!(video && video.readyState >= 2 && video.currentSrc);
      }

      function cancelPendingVideoClear() {
        if (clearVideoTimer) {
          clearTimeout(clearVideoTimer);
          clearVideoTimer = null;
        }
      }

      function clearLoadTimeout() {
        if (loadTimeoutTimer) {
          clearTimeout(loadTimeoutTimer);
          loadTimeoutTimer = null;
        }
      }

      function clearPopoverResetTimer() {
        if (resetPopoverTimer) {
          clearTimeout(resetPopoverTimer);
          resetPopoverTimer = null;
        }
      }

      function hardenVideoAttributes() {
        if (!stageVideo) return;
        try {
          stageVideo.muted = true;
          stageVideo.defaultMuted = true;
          stageVideo.loop = true;
          stageVideo.playsInline = true;
          stageVideo.setAttribute('muted', '');
          stageVideo.setAttribute('playsinline', '');
          stageVideo.setAttribute('webkit-playsinline', '');
          stageVideo.removeAttribute('controls');
        } catch (e) {}
      }

      function pauseStageVideo() {
        if (!stageVideo) return;
        try { stageVideo.pause(); } catch (e) {}
      }

      function fullyResetVideoElement() {
        if (!stageVideo) return;
        pauseStageVideo();
        clearLoadTimeout();

        try {
          stageVideo.classList.remove('is-visible');
          stageVideo.removeAttribute('poster');
          stageVideo.removeAttribute('src');
          stageVideo.load();
        } catch (e) {}

        if (stageVideo.dataset) {
          delete stageVideo.dataset.loadedVideoUrl;
          delete stageVideo.dataset.readyVideoUrl;
        }
      }

      function scheduleClearVideoAfterFadeOut(expectedRequestId) {
        cancelPendingVideoClear();
        clearVideoTimer = setTimeout(function () {
          if (!stageVideo) return;
          if (expectedRequestId !== activeRequestId) return;
          if (stageVideo.classList.contains('is-visible')) return;
          fullyResetVideoElement();
        }, VIDEO_FADE_MS + 50);
      }

      function rememberLoaded(url) {
        if (!url) return;
        if (!mediaCache[url]) mediaCache[url] = {};
        mediaCache[url].videoLoaded = true;
      }

      function rememberImage(url) {
        if (!url) return;
        if (!mediaCache[url]) mediaCache[url] = {};
        mediaCache[url].imageLoaded = true;
      }

      function preloadImageIfNeeded(src, callback) {
        if (!src || !stageImage || stageImage.tagName !== 'IMG') {
          callback();
          return;
        }

        var currentSrc = stageImage.getAttribute('src') || '';
        if ((currentSrc === src && stageImage.complete) || (mediaCache[src] && mediaCache[src].imageLoaded)) {
          callback();
          return;
        }

        var img = new Image();
        img.decoding = 'async';
        var done = false;

        function finish() {
          if (done) return;
          done = true;
          rememberImage(src);
          callback();
        }

        img.onload = finish;
        img.onerror = finish;
        img.src = src;
        if (img.complete) finish();
      }

      function showStageImage(src, alt, expectedRequestId) {
        if (!stageImage || !stageVideo) return;

        cancelPendingVideoClear();

        preloadImageIfNeeded(src, function () {
          if (expectedRequestId != null && expectedRequestId !== activeRequestId) return;

          if (stageImage.tagName === 'IMG' && src) {
            if (stageImage.getAttribute('src') !== src) stageImage.setAttribute('src', src);
            if (typeof alt === 'string') stageImage.setAttribute('alt', alt);
          }

          stageImage.classList.remove('is-hidden');

          requestAnimationFrame(function () {
            if (expectedRequestId != null && expectedRequestId !== activeRequestId) return;
            stageVideo.classList.remove('is-visible');
            scheduleClearVideoAfterFadeOut(activeRequestId);
          });
        });
      }

      function tryPlayStageVideo(expectedRequestId) {
        if (!stageVideo) return Promise.reject(new Error('No video element'));
        if (expectedRequestId !== activeRequestId) return Promise.reject(new Error('Stale request'));

        hardenVideoAttributes();

        try {
          var playResult = stageVideo.play();
          if (playResult && typeof playResult.then === 'function') return playResult;
          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }

      function revealStageVideo(expectedRequestId, url) {
        if (!stageVideo || !stageImage) return;
        if (expectedRequestId !== activeRequestId) return;

        cancelPendingVideoClear();
        clearLoadTimeout();
        rememberLoaded(url);

        if (stageVideo.dataset) {
          stageVideo.dataset.loadedVideoUrl = url;
          stageVideo.dataset.readyVideoUrl = url;
        }

        requestAnimationFrame(function () {
          if (expectedRequestId !== activeRequestId) return;
          stageVideo.classList.add('is-visible');
          stageImage.classList.add('is-hidden');
        });
      }

      function failVideoLoad(expectedRequestId, fallbackImageUrl, fallbackAlt) {
        if (expectedRequestId !== activeRequestId) return;
        clearLoadTimeout();
        showStageImage(fallbackImageUrl || defaultImageSrc, fallbackAlt || defaultImageAlt, expectedRequestId);
        if (stageVideo) stageVideo.classList.remove('is-visible');
      }

      function showStageVideo(videoUrl, posterUrl, fallbackImageUrl, fallbackAlt, expectedRequestId) {
        if (!stageVideo || !stageImage || !videoUrl) return;

        cancelPendingVideoClear();
        clearLoadTimeout();
        pauseStageVideo();
        hardenVideoAttributes();

        if (posterUrl) stageVideo.setAttribute('poster', posterUrl);
        else stageVideo.removeAttribute('poster');

        stageVideo.classList.remove('is-visible');
        stageImage.classList.remove('is-hidden');

        if (stageVideo.dataset && stageVideo.dataset.loadedVideoUrl === videoUrl && isVideoReady(stageVideo)) {
          tryPlayStageVideo(expectedRequestId)
            .then(function () {
              revealStageVideo(expectedRequestId, videoUrl);
            })
            .catch(function () {
              if (expectedRequestId !== activeRequestId) return;
              if (isVideoReady(stageVideo)) revealStageVideo(expectedRequestId, videoUrl);
              else failVideoLoad(expectedRequestId, fallbackImageUrl, fallbackAlt);
            });
          return;
        }

        if (stageVideo.getAttribute('src') !== videoUrl) {
          stageVideo.setAttribute('src', videoUrl);
        }

        if (stageVideo.dataset) delete stageVideo.dataset.readyVideoUrl;

        function onReadyMaybe() {
          if (expectedRequestId !== activeRequestId) return;
          if (!isVideoReady(stageVideo)) return;

          tryPlayStageVideo(expectedRequestId)
            .then(function () {
              revealStageVideo(expectedRequestId, videoUrl);
            })
            .catch(function () {
              if (expectedRequestId !== activeRequestId) return;
              if (isVideoReady(stageVideo)) revealStageVideo(expectedRequestId, videoUrl);
              else failVideoLoad(expectedRequestId, fallbackImageUrl, fallbackAlt);
            });
        }

        loadTimeoutTimer = setTimeout(function () {
          failVideoLoad(expectedRequestId, fallbackImageUrl, fallbackAlt);
        }, VIDEO_LOAD_TIMEOUT_MS);

        try {
          stageVideo.load();
        } catch (e) {
          failVideoLoad(expectedRequestId, fallbackImageUrl, fallbackAlt);
          return;
        }

        if (isVideoReady(stageVideo)) onReadyMaybe();
      }

      function getPopoverForButton(btn) {
        if (!btn) return null;
        var popId = btn.getAttribute('aria-controls');
        if (!popId) return null;
        return root.querySelector('#' + cssEscapeSafe(popId));
      }

      function hidePopover(pop, immediate) {
        if (!pop) return;
        pop.classList.remove('is-open');

        if (immediate) {
          pop.hidden = true;
          return;
        }

        clearPopoverResetTimer();
        resetPopoverTimer = setTimeout(function () {
          if (!pop.classList.contains('is-open')) pop.hidden = true;
        }, POPOVER_TRANSITION_MS);
      }

      function closeAllPopovers(immediate) {
        popovers.forEach(function (pop) {
          hidePopover(pop, immediate);
        });

        hotspotButtons.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });

        root.classList.remove('is-popover-open');
        mobileScrollStartY = window.scrollY || window.pageYOffset || 0;
        mobileScrollAccumulated = 0;

        if (defaultCopy) {
          defaultCopy.classList.remove('is-hidden');
        }
      }

      function setActiveButton(btn) {
        hotspotButtons.forEach(function (b) {
          b.setAttribute('aria-expanded', b === btn ? 'true' : 'false');
        });
        activeHotspotId = btn ? btn.getAttribute('data-hotspot-btn') : null;
      }

      function openPopoverForButton(btn) {
        var pop = getPopoverForButton(btn);
        if (!pop) return;

        closeAllPopovers(true);

        pop.hidden = false;

        if (!isDesktop() && defaultCopy) {
          defaultCopy.classList.add('is-hidden');
        }

        if (!isDesktop()) {
          root.classList.add('is-popover-open');
          mobileScrollStartY = window.scrollY || window.pageYOffset || 0;
          mobileScrollAccumulated = 0;
        }
        requestAnimationFrame(function () {
          pop.classList.add('is-open');
        });

        btn.setAttribute('aria-expanded', 'true');
      }

      function resetToDefault() {
        activeRequestId += 1;
        activeHotspotId = null;
        closeAllPopovers();
        clearLoadTimeout();
        cancelPendingVideoClear();

        if (defaultImageSrc) {
          showStageImage(defaultImageSrc, defaultImageAlt, activeRequestId);
        } else {
          if (stageImage) stageImage.classList.remove('is-hidden');
          if (stageVideo) {
            stageVideo.classList.remove('is-visible');
            scheduleClearVideoAfterFadeOut(activeRequestId);
          }
        }
      }

      function triggerHotspotRotation(btn) {
        if (!btn || prefersReducedMotion) return;
        btn.classList.remove('is-rotating');
        void btn.offsetWidth;
        btn.classList.add('is-rotating');

        window.setTimeout(function () {
          btn.classList.remove('is-rotating');
        }, ROTATE_MS);
      }

      function activateHotspot(btn) {
        if (!btn) return;

        var id = btn.getAttribute('data-hotspot-btn');
        var title = btn.getAttribute('data-hotspot-title') || '';
        var videoUrl = btn.getAttribute('data-hotspot-video') || '';
        var imageUrl = btn.getAttribute('data-hotspot-image') || '';
        var posterUrl = btn.getAttribute('data-hotspot-poster') || '';

        if (!imageUrl) imageUrl = posterUrl || defaultImageSrc;

        triggerHotspotRotation(btn);

        if (activeHotspotId === id) {
          resetToDefault();
          return;
        }

        activeRequestId += 1;
        var requestId = activeRequestId;

        setActiveButton(btn);

        if (videoUrl) {
          showStageImage(imageUrl, title, requestId);
          showStageVideo(videoUrl, posterUrl, imageUrl, title, requestId);
        } else if (imageUrl) {
          showStageImage(imageUrl, title, requestId);
        } else {
          showStageImage(defaultImageSrc, defaultImageAlt, requestId);
        }

        openPopoverForButton(btn);
      }

      function primeHotspotMedia(btn) {
        if (!btn) return;

        var videoUrl = btn.getAttribute('data-hotspot-video') || '';
        var imageUrl = btn.getAttribute('data-hotspot-image') || '';
        var posterUrl = btn.getAttribute('data-hotspot-poster') || '';

        if (imageUrl && !(mediaCache[imageUrl] && mediaCache[imageUrl].imageLoaded)) {
          var img1 = new Image();
          img1.decoding = 'async';
          img1.onload = function () { rememberImage(imageUrl); };
          img1.onerror = function () {};
          img1.src = imageUrl;
        }

        if (posterUrl && !(mediaCache[posterUrl] && mediaCache[posterUrl].imageLoaded)) {
          var img2 = new Image();
          img2.decoding = 'async';
          img2.onload = function () { rememberImage(posterUrl); };
          img2.onerror = function () {};
          img2.src = posterUrl;
        }

        if (videoUrl && (root.dataset.khbPreloadFirst === 'true')) {
          if (!(mediaCache[videoUrl] && mediaCache[videoUrl].preloaded)) {
            mediaCache[videoUrl] = mediaCache[videoUrl] || {};
            mediaCache[videoUrl].preloaded = true;
            try {
              var link = document.createElement('link');
              link.rel = 'preload';
              link.as = 'video';
              link.href = videoUrl;
              document.head.appendChild(link);
            } catch (e) {}
          }
        }
      }

      hotspotButtons.forEach(function (btn) {
        btn.addEventListener('mouseenter', function () { primeHotspotMedia(btn); }, { passive: true });
        btn.addEventListener('focus', function () { primeHotspotMedia(btn); });
        btn.addEventListener('touchstart', function () { primeHotspotMedia(btn); }, { passive: true });
        btn.addEventListener('pointerdown', function () { primeHotspotMedia(btn); }, { passive: true });

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          activateHotspot(btn);
        });
      });

      if ((root.dataset.khbPreloadFirst === 'true')) {
        for (var i = 0; i < hotspotButtons.length; i++) {
          var firstVideoUrl = hotspotButtons[i].getAttribute('data-hotspot-video') || '';
          var firstPosterUrl = hotspotButtons[i].getAttribute('data-hotspot-poster') || '';
          var firstImageUrl = hotspotButtons[i].getAttribute('data-hotspot-image') || '';

          if (firstImageUrl || firstPosterUrl) primeHotspotMedia(hotspotButtons[i]);

          if (firstVideoUrl) {
            try {
              var preloadLink = document.createElement('link');
              preloadLink.rel = 'preload';
              preloadLink.as = 'video';
              preloadLink.href = firstVideoUrl;
              document.head.appendChild(preloadLink);
            } catch (e) {}
            break;
          }
        }
      }

      root.querySelectorAll('.khb__close').forEach(function (x) {
        x.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          resetToDefault();
        });
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) resetToDefault();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') resetToDefault();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseStageVideo();
        } else if (activeHotspotId && stageVideo && stageVideo.classList.contains('is-visible')) {
          tryPlayStageVideo(activeRequestId).catch(function () {});
        }
      });

      window.addEventListener('pageshow', function () {
        if (activeHotspotId && stageVideo && stageVideo.classList.contains('is-visible')) {
          tryPlayStageVideo(activeRequestId).catch(function () {});
        }
      });

      window.addEventListener('scroll', function () {
        if (!activeHotspotId || isDesktop()) return;
        var currentScrollY = window.scrollY || window.pageYOffset || 0;
        mobileScrollAccumulated += Math.abs(currentScrollY - mobileScrollStartY);
        mobileScrollStartY = currentScrollY;
        if (mobileScrollAccumulated < MOBILE_SCROLL_CLOSE_THRESHOLD) return;
        resetToDefault();
      }, { passive: true });

      if (stageVideo) {
        stageVideo.addEventListener('loadedmetadata', function () {
          if (!stageVideo.currentSrc) return;
          if (stageVideo.dataset) stageVideo.dataset.readyVideoUrl = stageVideo.currentSrc;
        });

        stageVideo.addEventListener('loadeddata', function () {
          if (!activeHotspotId) return;
          if (!isVideoReady(stageVideo)) return;
          tryPlayStageVideo(activeRequestId)
            .then(function () {
              if (stageVideo.currentSrc) revealStageVideo(activeRequestId, stageVideo.currentSrc);
            })
            .catch(function () {
              if (stageVideo.currentSrc && isVideoReady(stageVideo)) {
                revealStageVideo(activeRequestId, stageVideo.currentSrc);
              }
            });
        });

        stageVideo.addEventListener('canplay', function () {
          if (!activeHotspotId) return;
          if (!isVideoReady(stageVideo)) return;
          tryPlayStageVideo(activeRequestId)
            .then(function () {
              if (stageVideo.currentSrc) revealStageVideo(activeRequestId, stageVideo.currentSrc);
            })
            .catch(function () {
              if (stageVideo.currentSrc && isVideoReady(stageVideo)) {
                revealStageVideo(activeRequestId, stageVideo.currentSrc);
              }
            });
        });

        stageVideo.addEventListener('error', function () {
          if (!activeHotspotId) return;

          var activeBtn = root.querySelector('[data-hotspot-btn="' + cssEscapeSafe(activeHotspotId) + '"]');
          var fallbackImage = activeBtn ? (activeBtn.getAttribute('data-hotspot-image') || activeBtn.getAttribute('data-hotspot-poster') || defaultImageSrc) : defaultImageSrc;
          var fallbackAlt = activeBtn ? (activeBtn.getAttribute('data-hotspot-title') || defaultImageAlt) : defaultImageAlt;

          failVideoLoad(activeRequestId, fallbackImage, fallbackAlt);
        });
      }

      function revealNodeList(nodes, step) {
        nodes.forEach(function (node, idx) {
          window.setTimeout(function () {
            node.classList.add('is-visible');
          }, idx * step);
        });
      }

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealNodeList(revealNodes, 60);
        benefitRevealNodes.forEach(function (node) { node.classList.add('is-visible'); });
      } else {
        if (revealNodes.length) {
          var textObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });

          revealNodes.forEach(function (node) { textObserver.observe(node); });
        }

        if (benefitRevealNodes.length) {
          var benefitRevealObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

          benefitRevealNodes.forEach(function (node) { benefitRevealObserver.observe(node); });
        }
      }

      if (benefitCards.length) {
        var benefitTicking = false;
        var activeBenefit = null;

        function setActiveBenefit(card) {
          if (activeBenefit === card) return;
          if (activeBenefit) activeBenefit.classList.remove('is-active');
          activeBenefit = card;
          if (activeBenefit) activeBenefit.classList.add('is-active');
        }

        function updateVisibleBenefit() {
          benefitTicking = false;
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          var best = null;
          var bestScore = 0;

          benefitCards.forEach(function (card) {
            if (!card.classList.contains('is-visible')) return;
            var r = card.getBoundingClientRect();
            var visibleTop = Math.max(r.top, 0);
            var visibleBottom = Math.min(r.bottom, vh);
            var visiblePx = Math.max(0, visibleBottom - visibleTop);
            var visibleRatio = visiblePx / Math.max(1, r.height);
            var center = r.top + (r.height / 2);
            var viewportCenter = vh * (Number(root.dataset.khbAnchor) / 100 || 0.5);
            var centerDist = Math.abs(center - viewportCenter);
            var centerScore = Math.max(0, 1 - (centerDist / Math.max(1, vh * 0.65)));
            var score = (visibleRatio * 0.65) + (centerScore * 0.35);

            if (score > bestScore) {
              bestScore = score;
              best = card;
            }
          });

          if (best && bestScore > 0.18) setActiveBenefit(best);
        }

        function onBenefitScrollResize() {
          if (benefitTicking) return;
          benefitTicking = true;
          window.requestAnimationFrame(updateVisibleBenefit);
        }

        window.addEventListener('scroll', onBenefitScrollResize, { passive: true });
        window.addEventListener('resize', onBenefitScrollResize);
        onBenefitScrollResize();
      }

      document.addEventListener('shopify:section:load', function (evt) {
        if (!evt || !evt.target || !evt.target.querySelector) return;
        if (!evt.target.querySelector('#' + root.id)) return;
        hardenVideoAttributes();
      });

      hardenVideoAttributes();
    
  }
  function khbBoot() {
    document.querySelectorAll('[id^="khb-"].khb').forEach(initKhb);
  }
  khbBoot();
  document.addEventListener('shopify:section:load', khbBoot);
})();
